__turbopack_context__.v({
  "fade-in": "Award-module-scss-module__SPBV3W__fade-in",
  "isDark": "Award-module-scss-module__SPBV3W__isDark",
  "root": "Award-module-scss-module__SPBV3W__root",
});
